import * as angular from 'angular';
import { CleaningTaskConfiguration, ComponentDefinition } from '../../models/';
import { ILoggerService, ITaskService } from '../../services/';

class DataCleaningController implements angular.IComponentController {
    cleaningTask: CleaningTaskConfiguration;
    isLoading: boolean;
    loadingMessage: string;

    static $inject = [
        'loggerService',
        'taskService'
    ];

    constructor(
        private _loggerService: ILoggerService,
        private _taskService: ITaskService
    ) {
    }

    /**
     * Initialization
     */
    $onInit() {
        this.cleaningTask = {} as CleaningTaskConfiguration;
        this.cleaningTask.hasDeleteUnusedTagData = true;
        this.cleaningTask.hasDeletePhantomTasks = false;
    }

    /**
     * Execute selected maintenance tasks
     */
    execute(): void {
        if (this.hasTasks()) {
            this.isLoading = true;
            this.cleaningTask.databaseGuid = null;

            this._taskService
                .createCleaningTask(this.cleaningTask)
                .then(response => {
                    this._loggerService.logSuccess('Cleaning started.');
                })
                .catch(response => {
                    this._loggerService.logError('Failed to start cleaning.');
                })
                .finally(() => this.isLoading = false);
        }
    }

    /** 
     * Check if there's at least one task checked
     * Add new tasks in return
     */
    hasTasks(): boolean {
        return this.cleaningTask.hasDeleteUnusedTagData || this.cleaningTask.hasDeletePhantomTasks;
    }
}

export const wtDataCleaning: ComponentDefinition = {
    componentId: 'wtDataCleaning',
    controller: DataCleaningController,
    template: require('./dataCleaning.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '=',
        loadingMessage: '='
    }
};
